import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import Separator from '@ublend-npm/aulaui-next-web/Separator';

import {
  DialogTitle,
  DialogContent,
  DialogActions,
} from '../../../common/Dialog';

import FieldSet, {
  TextField,
  Checkbox,
  FieldRow,
} from '../../../common/FieldSets';

const AutoGenerateGroupInner = ({ onClose, onGenerate, generating }) => {
  const [studentsPerGroup, setStudentsPerGroup] = useState(null);
  const handleStudentsPerGroupChange = (event) =>
    setStudentsPerGroup(parseInt(event.target.value, 10));

  const [hasConversation, setHasConversation] = useState(false);
  const handleGroupConversationChange = () =>
    setHasConversation(!hasConversation);
  const groupConversation = useMemo(
    () => (
      <FieldSet title="Group messages">
        <FieldRow>
          <Checkbox
            label="Create group conversation"
            checked={hasConversation}
            onChange={handleGroupConversationChange}
          />
        </FieldRow>
      </FieldSet>
    ),
    [hasConversation]
  );

  const handleOnGenerateClick = () =>
    onGenerate({
      studentsPerGroup,
      hasConversation,
    });

  const canGenerate = studentsPerGroup > 0;

  return (
    <React.Fragment>
      <DialogTitle id="auto-generate-group-dialogtitle" onClose={onClose}>
        Generate groups
      </DialogTitle>
      <DialogContent>
        <FieldSet title="Group settings">
          <FieldRow>
            <TextField
              id="students-per-grouo"
              label="Number of students per group"
              type="number"
              value={studentsPerGroup ? studentsPerGroup.toString() : ''}
              onChange={handleStudentsPerGroupChange}
            />
          </FieldRow>
        </FieldSet>
        <Separator />
        {groupConversation}
      </DialogContent>
      <DialogActions
        primary={{
          label: 'Create groups',
          disabled: !canGenerate,
          onClick: handleOnGenerateClick,
          loading: generating,
        }}
      />
    </React.Fragment>
  );
};

AutoGenerateGroupInner.propTypes = {
  onClose: PropTypes.func.isRequired,
  onGenerate: PropTypes.func.isRequired,
  generating: PropTypes.bool.isRequired,
};

export default AutoGenerateGroupInner;
